import { Loader } from '../../../../../components/loader/loader';
import { Page } from '../../../../../components/page/page';
import { useLang } from '../../../../../hooks/use-lang';
import { useIikoStore } from '../../../../../store/use-iiko-store';
import { MenuIikoHeader } from './menu-iiko-header/menu-iiko-header';
import s from './menu-iiko.module.css';
import { MenuIikoSlider } from './menu-iiko-slider/menu-iiko-slider';
import { getMenuId } from '../menu-informer/menu-informer-helpers';
import { MenuIikoTable } from './menu-iiko-table/menu-iiko-table';

export const MenuIiko = () => {
  const { t } = useLang();
  const { isLoading, list } = useIikoStore();
  const menuId = getMenuId();

  return (
    <Page className={s.page}>
      {isLoading && <Loader />}
      <MenuIikoHeader />
      <MenuIikoSlider />
      {!list?.length && (
        <div className={s.empty}>
          <div>
            <span>{t('У вас еще нет меню, пожалуйста')}</span>
            <br />
            <span>{t('Сихронизируйте его из iiko')}</span>
          </div>
        </div>
      )}

      {!!list?.length && !menuId && (
        <div className={s.empty}>
          <span>{t('Выберите меню')}</span>
        </div>
      )}

      {menuId && list?.length && <MenuIikoTable />}
    </Page>
  );
};
